import { useState } from "react";

export const AccountRemoved = () => {

    const [distance, setDistance] = useState<number>(50);
    const [sensitivity, setSensitivity] = useState<number>(80);

    return (
        <div className="overflow-hidden p-4 flex flex-col space-y-4">
            <fieldset className="border rounded-lg p-4">
                <h2 className="mb-4 font-sans font-medium">Anchors</h2>
                <label htmlFor="anchors-geolocated" className="text-gray-900 text-md me-4 inline-flex items-center font-sans text-sm font-normal">
                    <input
                        type="radio"
                        className="me-2 h-5 w-5"
                        id="anchors-geolocated"
                        name="anchors"
                    />
                    <span>Anchors Geolocated</span>
                </label>
                <label htmlFor="anchors-bind-to-viro-scene" className="text-gray-900 text-md me-4 inline-flex items-center font-sans text-sm font-normal">
                    <input
                        type="radio"
                        className="me-2 h-5 w-5"
                        id="anchors-bind-to-viro-scene"
                        name="anchors"
                    />
                    <span>Anchors bind to Viro scene</span>
                </label>
            </fieldset>
            <fieldset className="border rounded-lg p-4 w-full">
                <h2 className="mb-5 font-sans font-medium">Display Distance</h2>
                <label htmlFor="display-distance" className="text-gray-900 text-md block items-center font-sans text-sm font-normal w-full">
                    <div className="relative h-3 w-5/6 bg-gray-200 rounded-full mb-3">
                        <span className="bg-[#2DE1FF] absolute h-full w-5 rounded-full z-0" style={{width: `${(distance/300)*100}%`}}></span>
                        <input
                            type="range"
                            className="h-full w-full z-20 relative rounded-full appearance-none bg-transparent [&::-webkit-slider-thumb]:bg-[#2DE1FF] [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:mt-[-6px] [&::-webkit-slider-thumb]:w-5 [&::-webkit-slider-thumb]:h-5 [&::-webkit-slider-thumb]:rounded-full"
                            id="display-distance"
                            name="display-distance"
                            value={distance}
                            min="5"
                            max="300"
                            step="1"
                            onChange={(e) => { setDistance(parseInt(e.target.value)) }}
                        />
                    </div>
                    <p className="font-sans block text-sm font-medium mb-0">Distance: {distance} metres</p>
                </label>
            </fieldset>
            <fieldset className="border rounded-lg p-4 w-full">
                <h2 className="mb-5 font-sans font-medium">Core motion</h2>
                <label htmlFor="show-coremotion-data" className="text-gray-900 text-md me-4 block items-center font-sans text-sm font-normal mb-4">
                    <input
                        type="checkbox"
                        className="me-2"
                        id="show-coremotion-data"
                        name="show-coremotion-data"
                    />
                    <span>Show CoreMotion data</span>
                </label>
                <label htmlFor="use-pedometer" className="text-gray-900 text-md me-4 block items-center font-sans text-sm font-normal mb-6">
                    <input
                        type="checkbox"
                        className="me-2"
                        id="use-pedometer"
                        name="use-pedometer"
                    />
                    <span>Use pedometer</span>
                </label>
                <label htmlFor="display-distance" className="text-gray-900 text-md block items-center font-sans text-sm font-normal w-full">
                    <div className="relative h-3 w-5/6 bg-gray-200 rounded-full mb-3">
                        <span className="bg-[#2DE1FF] absolute h-full w-5 rounded-full z-0" style={{width: `${sensitivity}%`}}></span>
                        <input
                            type="range"
                            className="h-full w-full z-20 relative rounded-full appearance-none bg-transparent [&::-webkit-slider-thumb]:bg-[#2DE1FF] [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:mt-[-6px] [&::-webkit-slider-thumb]:w-5 [&::-webkit-slider-thumb]:h-5 [&::-webkit-slider-thumb]:rounded-full"
                            id="display-distance"
                            name="display-distance"
                            value={sensitivity}
                            min="0"
                            max="100"
                            step="1"
                            onChange={(e) => { setSensitivity(parseInt(e.target.value)) }}
                        />
                    </div>
                    <p className="font-sans block text-sm font-medium mb-0">Accelerometer Sensitivity: {sensitivity}%</p>
                </label>
            </fieldset>
            <fieldset className="border rounded-lg p-4">
                <h2 className="mb-4 font-sans font-medium">Perspective Views</h2>
                <label htmlFor="3d-buildings" className="text-gray-900 text-md me-4 inline-flex items-center font-sans text-sm font-normal">
                    <input
                        type="radio"
                        className="me-2 h-5 w-5"
                        id="3d-buildings"
                        name="perspective-views"
                    />
                    <span>3D Buildings</span>
                </label>
                <label htmlFor="2d-buildings" className="text-gray-900 text-md me-4 inline-flex items-center font-sans text-sm font-normal">
                    <input
                        type="radio"
                        className="me-2 h-5 w-5"
                        id="2d-buildings"
                        name="perspective-views"
                    />
                    <span>2D Buildings</span>
                </label>
            </fieldset>
        </div>
    )
}